<h1
  #reviewHeading
  class="nordic-blue-900-text mr-large-b font-heading-3 focus-inset"
  tabindex="-1"
  data-testid="upgrade-passenger-title-in-review-page"
>
  {{ 'oneUpgrade.pageTitle.review' | finLocalization }}
</h1>
<ng-container *finClientOnly="true">
  <fin-upgrade-passenger-selection class="block mr-xsmall-b"></fin-upgrade-passenger-selection>
  <fin-upgrade-review-bounds class="block mr-xsmall-b"></fin-upgrade-review-bounds>
  <div class="mobile-bleed">
    <div class="white-bg pr-medium border rounded-medium mr-xsmall-b">
      <div class="flex flex--space-between grand-total">
        <h3 class="grand-total-text nordic-blue-900-text font-heading-5">
          {{ 'oneUpgrade.review.grandTotal' | finLocalization }}
        </h3>

        <p class="grand-total-text nordic-blue-900-text font-body-1 bold-type align-right">
          <span class="payment-amount" *ngFor="let payment of selectedPayments$ | async; let last = last">
            {{ payment }}<ng-container *ngIf="!last">,</ng-container>
          </span>
        </p>
      </div>
    </div>
  </div>
</ng-container>
